module.exports = __webpack_public_path__ + "static/media/DSCF8023420wejdw.cd18443f.jpg";